import React, { useState } from 'react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import TextField from './TextField';

export default function PasswordField(props) {
  const [visible, setVisible] = useState(false);
  return (
    <TextField
      {...props}
      type={visible ? 'text' : 'password'}
      suffix={(
        <button
          type="button"
          className="input__addon input__addon--button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Hide password' : 'Show password'}
        >
          {visible ? <IconEyeOff size={22} /> : <IconEye size={22} />}
        </button>
      )}
    />
  );
}
